// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"122":"61a2b6c7","264":"c7de7b8e","461":"ce3a1e3b","770":"b1b46d53"}[chunkId] + ".chunk.css";
};